import { defineMessages, IntlShape } from "react-intl";

import RecordPaneTab from "@app/enum/preview/RecordPaneTab";

const messages = defineMessages({
  [RecordPaneTab.ACTIVITIES]: {
    id: "companyRecordPane.content.tabs.activities",
    defaultMessage: "Activities",
    description: "Activities tab title in Company Record pane",
  },
  [RecordPaneTab.DETAILS]: {
    id: "companyRecordPane.content.tabs.details",
    defaultMessage: "Details",
    description: "Details tab title in Company Record pane",
  },
  [RecordPaneTab.EMAILS]: {
    id: "companyRecordPane.content.tabs.emails",
    defaultMessage: "Emails",
    description: "Emails tab title in Company Record pane",
  },
  [RecordPaneTab.FILES]: {
    id: "companyRecordPane.content.tabs.files",
    defaultMessage: "Files",
    description: "Files tab title in Company Record pane",
  },
  [RecordPaneTab.NOTES]: {
    id: "companyRecordPane.content.tabs.notes",
    defaultMessage: "Notes",
    description: "Notes tab title in Company Record pane",
  },
  [RecordPaneTab.RELATIONSHIPS]: {
    id: "companyRecordPane.content.tabs.relationships",
    defaultMessage: "Relationships",
    description: "Relationships tab title in Company Record pane",
  },
});

const getTabDisplayName = (intl: IntlShape, tab: RecordPaneTab) =>
  intl.formatMessage(messages[tab]);

export default getTabDisplayName;
